export default "__VITE_ASSET__rNrAox6e__"